/**
 * @generated SignedSource<<996a5a7971c9154e8f0689ad65db37f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorCardFragment_staffProfile$data = {
  readonly id: string;
  readonly instructorDepartmentProfile: {
    readonly headline: string | null | undefined;
  };
  readonly lessonTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly archivedAt: string | null | undefined;
        readonly id: string;
        readonly visibleToMembers: boolean | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"lessonTypeHasRateForMembershipType_lessonType">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly fullName: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"InstructorPhotoFragment_staffProfile">;
  readonly " $fragmentType": "InstructorCardFragment_staffProfile";
};
export type InstructorCardFragment_staffProfile$key = {
  readonly " $data"?: InstructorCardFragment_staffProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_staffProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "facilitySlug",
    "variableName": "facilitySlug"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilitySlug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorCardFragment_staffProfile",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorPhotoFragment_staffProfile"
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "InstructorDepartmentProfile",
      "kind": "LinkedField",
      "name": "instructorDepartmentProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "LessonTypeConnection",
      "kind": "LinkedField",
      "name": "lessonTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "archivedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visibleToMembers",
                  "storageKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "lessonTypeHasRateForMembershipType_lessonType",
                  "selections": [
                    {
                      "alias": "lessonTypeRates",
                      "args": null,
                      "concreteType": "LessonRateConnection",
                      "kind": "LinkedField",
                      "name": "rates",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LessonRateEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "LessonRate",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "allMembershipTypes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ClientTypeConnection",
                                  "kind": "LinkedField",
                                  "name": "membershipTypes",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ClientTypeEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": null,
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v0/*: any*/)
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StaffUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};
})();

(node as any).hash = "35153ff727d9f13385f6c1281b1b71f2";

export default node;
